import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useApp } from "../context/AppContext";
import { CATEGORIES, catL10n, catPathFor } from "../lib/categories";

export default function Categories() {
  const { t, lang } = useApp();
  const homepageCategories = CATEGORIES.filter((category) => category.homeCategoryCard);

  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
      <div className="mb-12 max-w-2xl">
        <h2 className="font-serif-lux font-bold text-3xl sm:text-4xl lg:text-5xl text-slate-900">{t.category.popularTitle}</h2>
        <p className="mt-4 text-slate-600 text-base leading-relaxed">{t.category.popularSub}</p>
      </div>
      <div
        data-testid="popular-categories"
        className="grid gap-5 sm:grid-cols-2 lg:grid-cols-5"
      >
        {homepageCategories.map((cat) => {
          const L = catL10n(cat, lang);
          return (
            <Link
              key={cat.key}
              to={catPathFor(cat)}
              data-testid={`home-category-${cat.key}`}
              className="group relative aspect-[4/5] overflow-hidden rounded-2xl border border-slate-200 shadow-sm transition-[box-shadow,transform] duration-500 hover:-translate-y-1.5 hover:shadow-xl"
            >
              <img
                src={cat.image}
                alt={L.name}
                data-testid={`category-image-${cat.key}`}
                width="800"
                height="1000"
                loading="lazy"
                decoding="async"
                className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="font-serif-lux font-bold text-white text-xl">{L.name}</h3>
                <p className="text-slate-300 text-xs mt-1">{L.sub}</p>
                <span className="inline-flex items-center gap-1.5 mt-3 text-teal-300 text-xs font-semibold group-hover:gap-2.5 transition-all duration-300">
                  {t.category.explore} <ArrowRight size={14} />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
